module.exports = __webpack_public_path__ + "img/UVC4.7bd01345.png";